import React from "react";
import { useNavigate } from "react-router-dom";

const ReunionHero = () => {
  const navigate = useNavigate();

  return (
    <div className="relative min-h-[100dvh] flex flex-col items-center justify-center overflow-hidden px-4 bg-gradient-to-br from-emerald-950 via-teal-950 to-purple-950 text-white">

      {/* Background Glow */}
      <div className="absolute inset-0 bg-[radial-gradient(at_50%_20%,rgba(16,185,129,0.18),transparent_65%)]"></div>
      <div className="absolute inset-0 bg-[radial-gradient(at_20%_80%,rgba(34,197,94,0.12),transparent_60%)]"></div>
      <div className="absolute inset-0 bg-[radial-gradient(at_80%_70%,rgba(147,51,234,0.12),transparent_60%)]"></div>

      <div className="relative z-10 max-w-5xl mx-auto text-center">

        {/* Badge */}
        <div className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-md px-6 py-2 rounded-full border border-white/20 mb-6">
          <span className="text-xl">🫂</span>
          <span className="tracking-[0.25em] uppercase text-xs font-semibold text-emerald-100">
            Think5Whys • PurpleDoor • Reunion
          </span>
        </div>

        {/* Heading */}
        <h1 className="text-xl lg:text-4xl font-black tracking-tight leading-tight mb-6 bg-gradient-to-r from-white via-emerald-100 to-cyan-200 bg-clip-text text-transparent">
          Celebrate Together.
          <br />
          Connect Forever.
        </h1>

        {/* Tagline */}
        <p className="text-lg lg:text-xl text-emerald-100 font-medium mb-3">
          Every Gathering Deserves a Memorable Reunion.
        </p>

        {/* Description */}
        <p className="max-w-3xl mx-auto text-sm lg:text-lg leading-relaxed text-emerald-100/90 mb-8">
          Create exciting live community events for housing societies, schools,
          colleges, corporate meetings, birthdays, family reunions, festivals,
          religious gatherings and celebrations. Join instantly using an Entry
          Pass, play together, compete live and celebrate the winners.
        </p>

        {/* CTA Buttons */}
        <div className="flex flex-col lg:flex-row items-center justify-center gap-2">

          <button
            onClick={() => navigate("/reunion/organisor-dashboard")}
            className="w-72 lg:w-auto px-5 py-2 rounded-xl text-sm lg:text-lg font-semibold bg-gradient-to-r from-emerald-500 to-green-600 hover:scale-105 active:scale-95 transition-all shadow-xl shadow-emerald-500/30"
          >
            🎤 Organizer Dashboard
          </button>

          <button
            onClick={() => navigate("/reunion/play")}
            className="w-72 lg:w-auto px-5 py-2 rounded-xl text-sm lg:text-lg font-semibold bg-gradient-to-r from-violet-500 to-purple-600 hover:scale-105 active:scale-95 transition-all shadow-xl shadow-violet-500/30"
          >
            ▶️ Play Now
          </button>

          <button
            onClick={() =>
              document
                .getElementById("before-you-play")
                ?.scrollIntoView({ behavior: "smooth" })
            }
            className="w-72 lg:w-auto px-5 py-2 rounded-xl text-sm lg:text-lg border border-white/25 hover:border-white/60 backdrop-blur-md font-semibold transition-all"
          >
            📖 Before You Play
          </button>

        </div>
      </div>

      {/* Floating Celebration Icons */}
      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 flex gap-8 text-2xl lg:text-3xl opacity-80">

        <div className="animate-bounce">🫂</div>

        <div className="animate-bounce delay-150">🎉</div>

        <div className="animate-bounce delay-300">🏆</div>

        <div className="animate-bounce delay-[450ms]">🎊</div>

      </div>
    </div>
  );
};

export default ReunionHero;